import {elementFullScreen} from '../../../../../static/scripts/util/third_util';
import {
  btnEventCodeConst,
  dataConst,
  elementNameConst,
  identityConst,
  modesConst,
  stateConst
} from '../../conf';
import {getIdStr, getTpShapeAttrById, saveTopologyAllGraphData} from '../../data';

/**
 * 拓扑插件-拓扑逻辑处理相关代码
 */


/**
 * 拓扑插件-绘制事件-处理拖动图形生成并渲染事件
 * @param that vue实例
 * @param evt 原生事件
 */
export function handleDropAddShapeEvent(that, evt) {

  let data = evt.dataTransfer.getData('tp:element:ShapeAttribute');
  if (!data) {
    return;
  }

  data = JSON.parse(data);
  if (data?.moduleIdentity === identityConst.componentInfo) {

    // 如果是组件信息，则加载对应监视列表
    that.$bus.$emit('tp:aside:tabsChangeShowDialog', true, data.elementIdentity);

  } else {

    const stage = that.getCanvasStage();
    let attr;
    if (data?.elementAttr) {
      attr = data.elementAttr;
    } else {
      attr = getTpShapeAttrById(data?.eleId);
    }

    if (!attr) {
      return;
    }
    delete attr.elementId;

    // 重新生成ID，否则只能生成一个节点
    attr.id = getIdStr();
    attr.idField = attr.id;
    attr.tpId = that.getTpId();
    attr.x = evt?.canvasX || evt?.offsetX || 0;
    attr.y = evt?.canvasY || evt?.offsetY || 0;

    stage.addItem(elementNameConst.node, attr);
  }
}


/**
 * 拓扑插件-逻辑处理-处理顶部按钮事件
 * @param that vue实例引用
 * @param command 按钮命令
 */
export function handleHeaderButtonClickEvent(that, command) {
  // 处理顶部按钮事件
  switch (command) {
    case btnEventCodeConst.saveData:
      // 保存数据
      handleHeadBtnSaveDataEvent(that);
      break;
    case btnEventCodeConst.undoOperate:
      // 撤销操作
      handleHeadBtnUndoEvent(that);
      break;
    case btnEventCodeConst.redoOperate:
      // 恢复操作
      handleHeadBtnRedoEvent(that);
      break;
    case btnEventCodeConst.selectShape:
      // 激活选择图形
      handleHeadBtnSelectedOrJoinLineStatus(that, true);
      break;
    case btnEventCodeConst.joinLineShape:
      // 激活图形连线
      handleHeadBtnSelectedOrJoinLineStatus(that, false);
      break;
    case btnEventCodeConst.copyShape:
      // 复制图形
      handleHeadBtnCopyShapeEvent(that);
      break;
    case btnEventCodeConst.transparency:
      // 图形透明度设置
      handleHeadBtnTransparencyChangeEvent(that);
      break;
    case btnEventCodeConst.layerTop:
    case btnEventCodeConst.layerBottom:
    case btnEventCodeConst.layerUp:
    case btnEventCodeConst.layerDown:
      // 图形置顶
      handleHeadBtnLayerOperateEvent(that, command);
      break;
    case btnEventCodeConst.groupShape:
    case btnEventCodeConst.ungroupShape:
      // 组合、取消组合图形
      handleHeadBtnGroupOrUngroupShapeEvent(that, command);
      break;
    case btnEventCodeConst.lockShape:
    case btnEventCodeConst.unlockShape:
      // 锁定、取消锁定图形
      handleHeadBtnLockOrUnlockShapeEvent(that, command);
      break;
    case btnEventCodeConst.deleteShape:
      // 删除图形
      handleHeadBtnDeleteShapeEvent(that);
      break;
    case btnEventCodeConst.fullScreen:
      // 全屏
      handleHeaderBtnFullScreenEvent(that);
      break;
    case btnEventCodeConst.windowLeft:
      // 显示/隐藏左侧组件栏
      handleHeadBtnShapeShowHideEvent(that);
      break;
    case btnEventCodeConst.windowRight:
      // 显示/隐藏右侧属性栏事件
      handleHeadBtnAttributeShowHideEvent(that);
      break;
    case btnEventCodeConst.clearCanvasGraph:
      // 清空画布图形
      handleClearCanvasGraph(that);
      break;
    case btnEventCodeConst.canvasZoomIn:
      // 画布放大
      handleScaleZoomInEvent(that);
      break;
    case btnEventCodeConst.canvasZoomOut:
      // 画布缩小
      handleScaleZoomOutEvent(that);
      break;
    case btnEventCodeConst.canvasFitView:
      // 画布适应屏幕
      handleScaleAutoZoom(that);
      break;
    case btnEventCodeConst.canvasActualSize:
      // 画布实际大小
      handleScaleRealZoom(that);
      break;
    case btnEventCodeConst.selectAllGraph:
      // 选择画布所有图形
      handleSelectCanvasAllGraph(that);
      break;
    default:
      console.warn('无事件可处理');
      break;
  }
}


/**
 * 拓扑插件-逻辑处理-处理顶部按钮-保存画布数据事件
 * @param that vue实例
 */
export function handleHeadBtnSaveDataEvent(that) {
  const data = that.getCanvasStage().save();
  data.tpId = that.getTpId();
  saveTopologyAllGraphData(data).then(resp => {
    if (resp.code === '00000') {
      that.$message.success(resp?.message);
    } else {
      that.$message.warning(resp?.message);
    }
  });
}


/**
 * 拓扑插件-逻辑处理-处理顶部按钮-更新框选或连线激活状态，二者只能激活一种
 * @param that vue实例
 * @param status true 激活选中状态取消连线状态，false 激活连线状态取消选中状态
 */
export function handleHeadBtnSelectedOrJoinLineStatus(that, status) {
  that.tpOptions.selectedActive = status;
  that.tpOptions.joinLineActive = !status;
  that.getCanvasStage().setMode(status ? modesConst.default : modesConst.joinLine);
}


/**
 * 拓扑插件-逻辑处理-处理顶部按钮-复制图形事件
 * @param that vue实例
 */
export function handleHeadBtnCopyShapeEvent(that) {
  that.getCanvasStage().emit('custom:editor:copyNode');
}


/**
 * 拓扑插件-逻辑处理-处理顶部按钮-处理选定图形透明度改变事件
 * @param that vue实例
 * @param opacity 透明度
 */
export function handleHeadBtnTransparencyChangeEvent(that, opacity) {

}


/**
 * 拓扑插件-逻辑处理-处理顶部按钮-处理选定图形图层上、下移层或置顶等操作
 * @param that vue实例
 * @param command 命令
 */
export function handleHeadBtnLayerOperateEvent(that, command) {
  // 查询所有选中的元素
  const nodes = that.getCanvasStage().findAllByState(elementNameConst.node, stateConst.selected);
  const combos = that.getCanvasStage().findAllByState(elementNameConst.combo, stateConst.selected);
  const shapeArray = [...nodes, ...combos];
  shapeArray?.forEach(item => {
    if (command === btnEventCodeConst.layerTop) {
      item.toFront();
    } else if (command === btnEventCodeConst.layerBottom) {
      item.toBack();
    }
  });
}


/**
 * 拓扑插件-逻辑处理-处理顶部按钮-处理选定图形组合、取消组合操作
 * @param that vue实例
 * @param command 命令
 */
export function handleHeadBtnGroupOrUngroupShapeEvent(that, command) {

}

/**
 * 拓扑插件-逻辑处理-处理顶部按钮-处理顶部按钮-显示/隐藏左侧组件栏事件
 * @param that vue实例
 * @param command 命令
 */
export function handleHeadBtnLockOrUnlockShapeEvent(that, command) {
  // 查询所有选中的元素
  const nodes = that.getCanvasStage().findAllByState(elementNameConst.node, stateConst.selected);
  const combos = that.getCanvasStage().findAllByState(elementNameConst.combo, stateConst.selected);
  const shapeArray = [...nodes, ...combos];
  shapeArray?.forEach(item => {
    if (command === btnEventCodeConst.lockShape) {
      item.lock();
    } else if (command === btnEventCodeConst.unlockShape) {
      item.unlock();
    }
  });
}


/**
 * 拓扑插件-逻辑处理-处理顶部按钮-显示/隐藏左侧组件栏事件
 * @param that vue实例
 */
export function handleHeaderBtnFullScreenEvent(that) {
  elementFullScreen(elementNameConst.defaultCanvasWrapperName);
}


/**
 * 拓扑插件-逻辑处理-处理顶部按钮-显示/隐藏左侧组件栏事件
 * @param that vue实例
 */
export function handleHeadBtnShapeShowHideEvent(that) {
  that.tpOptions.showAside = !that.tpOptions.showAside;
}

/**
 * 拓扑插件-逻辑处理-处理顶部按钮-显示/隐藏右侧属性栏事件
 * @param that vue实例
 */
export function handleHeadBtnAttributeShowHideEvent(that) {
  that.tpOptions.showAttribute = !that.tpOptions.showAttribute;
}


/**
 * 拓扑插件-逻辑处理-处理顶部按钮-删除图形事件
 * @param that vue实例
 */
export function handleHeadBtnDeleteShapeEvent(that) {
  that.getCanvasStage().emit('custom:editor:deleteNode');
}


/**
 * 拓扑插件-逻辑处理-处理撤销操作
 * that vue实例
 */
export function handleHeadBtnUndoEvent(that) {
  const stage = that.getCanvasStage();
  const undoStack = stage.getUndoStack();
  if (!undoStack || undoStack.length === 1) {
    return;
  }

  const currentData = undoStack.pop();
  if (currentData) {
    const {action} = currentData;
    stage.pushStack(action, {...currentData.data}, 'redo');
    let data = currentData.data.before;

    if (action === 'add') {
      data = currentData.data.after;
    }

    if (!data) return;

    switch (action) {
      case 'visible': {
        handleHeaderBtnUndoOrRedoVisible(stage, data);
        break;
      }
      case 'render':
      case 'update':
        handleHeaderBtnUndoOrRedoRenderAndUpdate(stage, data);
        break;
      case 'changedata':
        stage.changeData(data, false);
        break;
      case 'delete': {
        Object.keys(data).forEach((key) => {
          const array = data[key];
          if (!array) return;
          array.forEach((model) => {
            const itemType = model.itemType;
            delete model.itemType;
            stage.addItem(itemType, model, false);
          });
        });
        break;
      }
      case 'add':
        Object.keys(data).forEach((key) => {
          const array = data[key];
          if (!array) return;
          array.forEach((model) => {
            stage.removeItem(model.id, false);
          });
        });
        break;
      case 'updateComboTree':
        handleHeaderBtnUndoOrRedoUpdateComboTree(stage, data);
        break;
      case 'layout':
        stage.updateLayout(data, undefined, undefined, false);
        break;
      default:
    }
  }
}


/**
 * 拓扑插件-逻辑处理-处理恢复/重做操作
 * that vue实例
 */
export function handleHeadBtnRedoEvent(that) {
  const stage = that.getCanvasStage();
  const redoStack = stage.getRedoStack();

  if (!redoStack || redoStack.length === 0) {
    return;
  }

  const currentData = redoStack.pop();
  if (currentData) {
    const {action} = currentData;
    let data = currentData.data.after;
    stage.pushStack(action, {...currentData.data});
    if (action === 'delete') {
      data = currentData.data.before;
    }

    if (!data) return;

    switch (action) {
      case 'visible': {
        handleHeaderBtnUndoOrRedoVisible(stage, data);
        break;
      }
      case 'render':
      case 'update':
        handleHeaderBtnUndoOrRedoRenderAndUpdate(stage, data);
        break;
      case 'changedata':
        stage.changeData(data, false);
        break;
      case 'delete':
        if (data.edges) {
          data.edges.forEach((model) => {
            stage.removeItem(model.id, false);
          });
        }
        if (data.nodes) {
          data.nodes.forEach((model) => {
            stage.removeItem(model.id, false);
          });
        }
        if (data.combos) {
          data.combos.forEach((model) => {
            stage.removeItem(model.id, false);
          });
        }
        break;
      case 'add': {
        Object.keys(data).forEach((key) => {
          const array = data[key];
          if (!array) return;
          array.forEach((model) => {
            const itemType = model.itemType;
            delete model.itemType;
            stage.addItem(itemType, model, false);
          });
        });
        break;
      }
      case 'updateComboTree':
        handleHeaderBtnUndoOrRedoUpdateComboTree(stage, data);
        break;
      case 'layout':
        stage.updateLayout(data, undefined, undefined, false);
        break;
      default:
    }
  }
}


/**
 * 拓扑插件-逻辑处理-处理撤销/恢复操作公共部分-Visible逻辑
 * @param stage 画布舞台对象
 * @param data 栈数据
 */
export function handleHeaderBtnUndoOrRedoVisible(stage, data) {
  Object.keys(data).forEach((key) => {
    const array = data[key];
    if (!array) return;
    array.forEach((model) => {
      const item = stage.findById(model.id);
      if (model.visible) {
        stage.showItem(item, false);
      } else {
        stage.hideItem(item, false);
      }
    });
  });
}


/**
 * 拓扑插件-逻辑处理-处理撤销/恢复操作公共部分-RenderAndUpdate逻辑
 * @param stage 画布舞台对象
 * @param data 栈数据
 */
export function handleHeaderBtnUndoOrRedoRenderAndUpdate(stage, data) {
  Object.keys(data).forEach((key) => {
    const array = data[key];
    if (!array) return;
    array.forEach((model) => {
      const item = stage.findById(model.id);
      delete model.id;
      stage.updateItem(item, model, false);
      if (item.getType() === elementNameConst.combo) {
        stage.updateCombo(item);
      }
    });
  });
}


/**
 * 拓扑插件-逻辑处理-处理撤销/恢复操作公共部分-UpdateComboTree逻辑
 * @param stage 画布舞台对象
 * @param data 栈数据
 */
export function handleHeaderBtnUndoOrRedoUpdateComboTree(stage, data) {
  Object.keys(data).forEach((key) => {
    const array = data[key];
    if (!array) return;
    array.forEach((model) => {
      stage.updateComboTree(model.id, model.parentId, false);
    });
  });
}


/**
 * 拓扑插件-逻辑处理-Zoom缩放操作-缩小处理
 * that vue 实例
 */
export function handleScaleZoomOutEvent(that) {
  const stage = that.getCanvasStage();
  const newZoom = stage.getZoom() - dataConst.ratio;
  const minZoom = stage.getMinZoom() || dataConst.minZoom;
  const ratio = newZoom < minZoom ? minZoom : newZoom;
  stage.zoomTo(ratio, stage.getGraphCenterPoint());
  return ratio;
}


/**
 * 拓扑插件-逻辑处理-Zoom缩放操作-放大处理
 * that vue 实例
 */
export function handleScaleZoomInEvent(that) {
  const stage = that.getCanvasStage();
  const newZoom = stage.getZoom() + dataConst.ratio;
  const maxZoom = stage.getMaxZoom() || dataConst.maxZoom;
  const ratio = newZoom > maxZoom ? maxZoom : newZoom;
  stage.zoomTo(ratio, stage.getGraphCenterPoint());
  return ratio;
}


/**
 * 拓扑插件-逻辑处理-Zoom缩放操作-实际大小处理
 * that vue 实例
 */
export function handleScaleRealZoom(that) {
  const stage = that.getCanvasStage();
  stage.zoomTo(dataConst.realZoom, stage.getGraphCenterPoint());
  return stage.getZoom();
}


/**
 * 拓扑插件-逻辑处理-Zoom缩放操作-适应屏幕处理
 * that vue 实例
 */
export function handleScaleAutoZoom(that) {
  const stage = that.getCanvasStage();
  stage.fitView([20, 20]);
  return stage.getZoom();
}


/**
 * 拓扑插件-逻辑处理-Zoom缩放操作-指定比例缩放处理
 * @param that vue 实例
 * @param number 缩放比例
 */
export function handleScaleZoomNumber(that, number) {
  const stage = that.getCanvasStage();
  const newZoom = Number(number) / 100;
  const minZoom = stage.getMinZoom() || dataConst.minZoom;
  const maxZoom = stage.getMaxZoom() || dataConst.maxZoom;
  const ratio = newZoom < minZoom ? minZoom : newZoom > maxZoom ? maxZoom : newZoom;
  stage.zoomTo(ratio, stage.getGraphCenterPoint());
  return ratio;
}


/**
 * 拓扑插件-逻辑处理-处理选择画布所有图形
 * @param that vue 实例
 */
export function handleSelectCanvasAllGraph(that) {
  const nodes = that.getCanvasStage().getNodes();
  nodes?.forEach(item => {
    item.setState(stateConst.selected, true);
  });
}


/**
 * 拓扑插件-逻辑处理-处理清空画布所有图形
 * @param that vue 实例
 */
export function handleClearCanvasGraph(that) {
  // 先选择所有图形
  handleSelectCanvasAllGraph(that);
  // 删除先中图形
  handleHeadBtnDeleteShapeEvent(that);
}


/**
 * 拓扑插件-节点-判断图形是否为节点
 * @param item 图形对象
 * @returns status true 节点，false 非节点
 */
export function isNode(item) {
  return item?.getType() === elementNameConst.node;
}


/**
 * 拓扑插件-边-判断图形是否为边
 * @param item 图形对象
 * @returns status true 边，false 非边
 */
export function isEdge(item) {
  return item?.getType() === elementNameConst.edge;
}


/**
 * 拓扑插件-combo-判断图形是否为combo
 * @param item 图形对象
 * @returns status true combo，false 非combo
 */
export function isCombo(item) {
  return item?.getType() === elementNameConst.combo;
}


export function savePicture() {
  this.graph.toFullDataURL(
    (res) => {
      const canvas = document.getElementById('networkCanvas');
      const background = document.getElementById('networkBackground');
      const img = new Image();
      img.onload = function() {
        // 画图
        canvas.width = img.width + 32;
        canvas.height = img.height + 32;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(background, 0, 0);
        ctx.drawImage(img, 16, 16);
        // 下载
        const oA = document.createElement('a');
        oA.download = '图片名称';
        oA.href = canvas.toDataURL('image/png');
        document.body.appendChild(oA);
        oA.click();
        oA.remove(); // 下载之后把创建的元素删除
      };
      img.src = res;
    },
    'image/png',
    {
      imageConfig: {
        padding: 16
      }
    }
  );


  // const imageUrl = require('../../../assets/images/fj-hei-0002.jpg');
  // const a = stage.getContainer();
  // a.style.background = '#000';
  // a.style.backgroundImage = 'url(' + imageUrl + ')';
  // // a.backgroundSize = 'cover';
  // a.style.backgroundSize = 'cover';


  // const url = require('../../../../assets/images/fj-hei-0002.jpg');
  // const backgroundImage = stage.getGroup().addShape('image', {
  //   attrs: {
  //     width: stage.getWidth(),
  //     height: stage.getHeight(),
  //     img: url
  //   },
  //   capture: false,
  //   zIndex: -999
  // });
  // console.log(backgroundImage, stage.getGroup());
  // backgroundImage.toBack();
}



